import { render, staticRenderFns } from "./programManagement.vue?vue&type=template&id=72587f37&"
import script from "./programManagement.vue?vue&type=script&lang=js&"
export * from "./programManagement.vue?vue&type=script&lang=js&"
import style0 from "./programManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72587f37')) {
      api.createRecord('72587f37', component.options)
    } else {
      api.reload('72587f37', component.options)
    }
    module.hot.accept("./programManagement.vue?vue&type=template&id=72587f37&", function () {
      api.rerender('72587f37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/RpaRobot/programManagement.vue"
export default component.exports